<template>
  <div id="app">
    <FourTimesFour/>
  </div>
</template>

<script>
import FourTimesFour from "./pages/FourTimesFour/FourTimesFour";

export default {
  name: "App",
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      let hbus = document.createElement('script')
      hbus.setAttribute('src', 'https://images.hepsiburada.net/hbus/hbus.min.v3.8.3.js')
      document.head.appendChild(hbus)
    }
  },
  components: {
    FourTimesFour
  },
};
</script>

<style src="./assets/styles/global.scss" lang="scss"/>



// WEBPACK FOOTER //
// src/App.vue